var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-warning",attrs:{"id":_vm.id}},[(_vm.title)?_c('h3',{staticClass:"text-warning"},[_c('exclamation-thick'),_vm._v(_vm._s(_vm.title))],1):_vm._e(),_c('p',{staticClass:"text-warning",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }